const REFRESH_PROPS = {
  isGil: true,
  domain: window.location?.hostname?.includes('localhost') ? '' : '.zinia.com',
};

export { REFRESH_PROPS };
